import { render } from "./MaintenanceHistoryPage.vue?vue&type=template&id=8b4cf8fc&ts=true"
import script from "./MaintenanceHistoryPage.vue?vue&type=script&lang=ts"
export * from "./MaintenanceHistoryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__